import React from 'react';

const Premium = () => {
    return (
        <div className='text-center' style={{ marginTop: '100px' }}>
            <h5 className='text-danger fs-2 fw-bold'>Premium Content</h5>
            <h6 className='text-light fs-5 mt-2'>Comming Soon........</h6>
        </div>
    );
};

export default Premium;